export class ChecklistConfigModel {
  id: number;
  active: boolean;
  required: boolean;
  itemTypeID: Number;
  facilityTypeID: Number;
  checklistID: number;
  changeTypeRefID: number;
  applicationCategoryID: number;
  facilityCategoryID: number;
  checklist: ChecklistModel;
}

export class ChecklistModel {
  id: number;
  name: string;
  description: string;
}


export class ChecklistItem {
  value: string;
  applicationID: number;
  checklistID: number;
}

export class ChecklistItemDetail {
  value: boolean;
  applicationID: number;
  checklistID: number;
  checkListRef : ChecklistModel;
}

